import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { VolunteerStatusId } from '@interfaces';
import { DomainDataService } from '../../../../../services';
import { VolunteeringAreaService } from '../../../volunteering-area.service';
import { VolunteeringAllVolunteersService } from '../../volunteering-all-volunteers.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'removed-volunteers-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './removed-volunteers.part.html',
})
export class RemovedVolunteersViewPart implements OnInit {

	private readonly util = inject(UtilityService);
	public readonly areaService = inject(VolunteeringAreaService);
	private readonly pageService = inject(VolunteeringAllVolunteersService);
	private readonly domainDataService = inject(DomainDataService);
	private readonly dialogService = inject(DialogService);

	public setup = computed(() => getSetup(this.areaService, this.util, this.domainDataService, this.dialogService, this.areaService.app));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public removedVolunteers = computed(() =>
		this.areaService.volunteeringData()?.volunteers.filter(
			v => v.volunteerStatusId === VolunteerStatusId.RemovedDueToInactivity ||
				v.volunteerStatusId === VolunteerStatusId.RemovedDueToCause ||
				v.volunteerStatusId === VolunteerStatusId.RemovedByRequest
		) ?? []
	);

	ngOnInit() {
		this.areaService.getVolunteeringData();
	}

}